/**
 * イージング関数
 *
 * @param {integer} t 現在の時間
 * @param {integer} b 開始値 (始点)
 * @param {integer} c 変化量 (終了値 - 開始値)
 * @param {integer} d 総時間
 * @returns
 */
export function easeInQuart(t, b, c, d) {
  return c * (t /= d) * t * t * t + b
}

/**
 * イージング関数
 *
 * @param {integer} x 現在の時間
 * @returns
 */
export function easeInCubic(x) {
  return x * x * x
}

/**
 * イージング関数
 *
 * @param {integer} x 現在の時間
 * @returns
 */
export function easeOutCubic(x) {
  return 1 - Math.pow(1 - x, 3)
}

/**
 * イージング関数
 *
 * @param {integer} t 現在の時間
 * @param {integer} b 開始値 (始点)
 * @param {integer} c 変化量 (終了値 - 開始値)
 * @param {integer} d 総時間
 * @returns
 */
export function easeQuinticOut(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b
}

/**
 * イージング関数
 *
 * @param {integer} start 開始値
 * @param {integer} end 終了値
 * @param {integer} multiplier 割合
 * @param {integer} fixed 少数第n位の扱い
 * @returns
 */
export function lerp(start, end, multiplier, fixed = 5) {
  return ((1 - multiplier) * start.fixed(fixed) + multiplier * end.fixed(fixed)).fixed(fixed)
}
